import { render, staticRenderFns } from "./GainDetail.vue?vue&type=template&id=2cef2e44&scoped=true"
import script from "./GainDetail.vue?vue&type=script&lang=js"
export * from "./GainDetail.vue?vue&type=script&lang=js"
import style0 from "./GainDetail.vue?vue&type=style&index=0&id=2cef2e44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cef2e44",
  null
  
)

export default component.exports